import { useQuery } from 'react-query';

import {
  getMemberAuthenticationFactors,
  type GetMemberAuthenticationFactorsInput,
} from 'modules/authentication-factor/api/getMemberAuthenticationFactors';

export const useGetMemberAuthenticationFactors = ({
  userId,
  companyId,
}: GetMemberAuthenticationFactorsInput) => {
  return useQuery(['memberAuthenticationFactors', companyId, userId], () =>
    getMemberAuthenticationFactors({
      userId,
      companyId,
    }),
  );
};
